import { FC } from "react"
import { classNames } from "../../utils/classNames"

interface BarGaugeProps {
  /** Current value to display */
  value: number
  /** Minimum value */
  min?: number
  /** Maximum value */
  max?: number
  /** Lower and upper bounds for typical values  */
  range?: [number, number]
}

export const BarGauge: FC<BarGaugeProps> = ({ value, min = 0, max = 0, range }) => {
  const hasRange = !!range && range.length === 2
  const colorRange: [number, number] = hasRange ? range : [min, max]
  const rangeStart = hasRange ? range[0] : null
  const rangeEnd = hasRange ? range[1] : null

  return (
    <div className="relative h-6 w-full max-w-[275px] min-w-[150px] rounded-sm bg-gray-100">
      {hasRange ? (
        <>
          <div
            className="absolute z-10 h-full w-0.5 bg-gray-600"
            style={{ left: `${calculatePositionPercent(rangeStart!, min, max)}%` }}></div>
          <div
            className="absolute z-10 h-full w-0.5 bg-gray-600"
            style={{ left: `${calculatePositionPercent(rangeEnd!, min, max)}%` }}></div>
        </>
      ) : null}
      <div
        className={classNames(
          "absolute left-0 h-full rounded-l-sm border-r-2",
          getValueColor(value, colorRange[0], colorRange[1]),
        )}
        style={{ width: `${calculatePositionPercent(value, min, max)}%` }}
      />
    </div>
  )
}

// Calculate the percentage based on where the value falls between min and max
const calculatePositionPercent = (value: number, min: number, max: number): number => {
  if (min === max) {
    return 0
  }

  const percent = ((value - min) / (max - min)) * 100

  // Ensure the percentage is between 0 and 100
  return Math.max(0, Math.min(100, percent))
}

const getValueColor = (value: number, min: number, max: number) => {
  if (value < min) {
    return `border-red-500 bg-red-200/40`
  } else if (value > max) {
    return `border-red-500 bg-red-200/40`
  } else {
    return `border-green-500 bg-green-200/50`
  }
}
